<template>
  <main class="unavailable-page">
    <div class="unavailable-card">
      <h1 class="unavailable-title">Trang không khả dụng</h1>
      <p class="unavailable-text">
        Phòng khám hiện không hỗ trợ đặt lịch trực tuyến. Vui lòng quay lại sau hoặc liên hệ trực tiếp với phòng khám.
      </p>
    </div>
  </main>
</template>

<script>
export default {
  name: "UnavailableView",
};
</script>

<style scoped>
.unavailable-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.unavailable-card {
  max-width: 480px;
  width: 100%;
  background-color: var(--white-color);
  border-radius: 12px;
  padding: 32px 24px;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.unavailable-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 16px;
}

.unavailable-text {
  font-size: 16px;
  color: var(--text-gray);
  line-height: 1.6;
}
</style>

